export class PatientCareLineRequest {

    public idHealthUnit: number | null = null;
    public idPatient: number | null = null;
    public hash: string = '';
    public listIdCareLine: number[] = [];
}